// libs
import { styled } from '@nykaa/ui-components';
import { css } from '@emotion/core';

// Icons
import CardDebitCard from '@nykaa/ui-components/Icons/card-debit-credit';
import Mobile from '@nykaa/ui-components/Icons/mobile';
import Help from '@nykaa/ui-components/Icons/help';

const marginRight = css`
  margin-right: ${({ theme }) => theme.spacing.spacing40};
`;

export const PromoBannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  font-family: Inter, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: ${({ theme }) => theme.colors.textPrimary};
  background: ${({ theme }) => theme.colors.surface};
  z-index: 12;
  width: 100vw;
  height: 56px;

  .sub-icons {
    display: flex;
    position: absolute;
    right: ${({ theme }) => theme.spacing.spacing240};
  }

  .app-download {
    width: 124px;
  }

  .header-logo-svg {
    margin-bottom: ${({ theme }) => theme.spacing.spacing50};
  }
`;

export const Banner = styled.div<{ bgColor: string }>`
  ${({ theme }) => theme.typography.bodySmall};
  height: 56px;
  color: ${({ theme }) => theme.colors.surface};
  width: 100%;
  position: relative;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ bgColor }) =>
    bgColor &&
    `
    background: ${bgColor};
  `};
`;

export const BannerSection = styled.div`
  display: flex;
  text-decoration: underline;
`;

export const Icon = styled.button<{ color: string }>`
  background: none;
  border: 0;
  cursor: pointer;
  margin-left: ${({ theme }) => theme.spacing.spacing120};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ color }) => color};

  &:first-of-type {
    margin: 0;
  }
`;

export const CardDebitIcon = styled(CardDebitCard)`
  ${marginRight};
`;

export const MobileIcon = styled(Mobile)`
  ${marginRight};
`;

export const HelpIcon = styled(Help)`
  ${marginRight};
`;
